// extracted by mini-css-extract-plugin
export default {"NewBoardButton":"new-board-button_NewBoardButton__52IZc","spinner":"new-board-button_spinner__L4rsX","plusIcon":"new-board-button_plusIcon__OaJdX"};